// src/componentes/common/KyeToast.jsx
import React, { useState, useEffect, useCallback } from "react";
import { _registerToastDispatch } from "./notify";
import "./KyeToast.css";

export default function KyeToast() {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  useEffect(() => {
    _registerToastDispatch((toast) => {
      setToasts((prev) => [...prev, toast]);
      setTimeout(() => dismiss(toast.id), toast.duration || 4000);
    });
  }, [dismiss]);

  if (!toasts.length) return null;

  return (
    <div className="kye-toast-container" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div key={t.id} className={`kye-toast kye-toast--${t.type}`} role="alert">
          <span className="kye-toast__icon">{ICONS[t.type]}</span>
          <span className="kye-toast__msg">{t.message}</span>
          <button
            className="kye-toast__close"
            onClick={() => dismiss(t.id)}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

const ICONS = {
  success: "✓",
  error:   "✕",
  warning: "⚠",
  info:    "i",
};
